var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.78539H11C11.553 4.78539 12 5.26068 12 5.84868C12 6.43668 11.553 6.91197 11 6.91197H6C5.447 6.91197 5 6.43668 5 5.84868C5 5.26068 5.447 4.78539 6 4.78539ZM7 15.9499C7 15.0695 7.672 14.355 8.5 14.355C9.328 14.355 10 15.0695 10 15.9499C10 16.8304 9.328 17.5449 8.5 17.5449C7.672 17.5449 7 16.8304 7 15.9499ZM14.5 18.6082C14.5 19.1951 14.052 19.6715 13.5 19.6715H3.5C2.948 19.6715 2.5 19.1951 2.5 18.6082V3.7221C2.5 3.13516 2.948 2.65881 3.5 2.65881H13.5C14.052 2.65881 14.5 3.13516 14.5 3.7221V18.6082ZM13.5 0.532227H3.5C1.846 0.532227 0.5 1.96342 0.5 3.7221V18.6082C0.5 20.3669 1.846 21.798 3.5 21.798H13.5C15.154 21.798 16.5 20.3669 16.5 18.6082V3.7221C16.5 1.96342 15.154 0.532227 13.5 0.532227Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.e9e5499ac0ebe7ed366958a5d6c16da1.svg";
export { ForwardRef as ReactComponent };